import { format } from "date-fns"

export function formatLocalIsoString(date: Date) {
  return format(date, "yyyy-MM-dd") + "T" + format(date, "HH:mm:ss.sss")
}
